import { render, staticRenderFns } from "./FormCheckbox.vue?vue&type=template&id=6fc5f477&scoped=true"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"
import style0 from "./FormCheckbox.vue?vue&type=style&index=0&id=6fc5f477&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc5f477",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc5f477')) {
      api.createRecord('6fc5f477', component.options)
    } else {
      api.reload('6fc5f477', component.options)
    }
    module.hot.accept("./FormCheckbox.vue?vue&type=template&id=6fc5f477&scoped=true", function () {
      api.rerender('6fc5f477', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/FormCheckbox.vue"
export default component.exports